// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared/for-apps";
import { equal } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { untracked } from "@angular/core";
@jsonClass('Orders.ExchangeRateHistory')
class Orders__ExchangeRateHistory {
    @jsonProperty(() => Orders__ExchangeRateHistory.Id)
    id: Orders__ExchangeRateHistory.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: unwrapReadonly(Object.freeze(["id", "date", "amountInChf", "exchangeRate", "exchangeRateId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: unwrapReadonly(Object.freeze(["id", "date", "amountInChf", "exchangeRate", "exchangeRateId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: unwrapReadonly(Object.freeze(["id", "date", "amountInChf", "exchangeRate", "exchangeRateId", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: unwrapReadonly(Object.freeze({ "date": "Date", "amountInChf": "number", "exchangeRate": "Orders.ExchangeRate", "exchangeRateId": "Orders.ExchangeRate.Id", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "number" } as const)),
        staticEntityProperties: unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: unwrapReadonly(Object.freeze({ exchangeRate: () => Orders.ExchangeRate } as const)),
        oneToManyRelationships: unwrapReadonly(Object.freeze({} as const)),
        oneToOneOwningRelationships: unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θdate = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θamountInChf = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θexchangeRate = Signals.proxySignalDeferred<Orders.ExchangeRate>(() => (undefined) as any);
    private readonly θexchangeRateId = Signals.proxySignalDeferred<Orders.ExchangeRate.Id>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Orders.ExchangeRateHistory' {
        return 'Orders.ExchangeRateHistory'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Orders.ExchangeRateHistory' {
        return 'Orders.ExchangeRateHistory'
    }

    static get __baseType(): 'Orders.ExchangeRateHistory' {
        return 'Orders.ExchangeRateHistory'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Orders.ExchangeRateHistory' {
        return 'Orders.ExchangeRateHistory'
    }

    get [BoInfoSymbol]() {
        return Orders__ExchangeRateHistory[BoInfoSymbol]
    }

    get date(): Date {
        return this.θdate?.()
    }

    set date(date) {
        this.θdate.set(coerceDataType(date, 'Date', false, true))
    }

    get amountInChf(): number {
        return this.θamountInChf?.()
    }

    set amountInChf(amountInChf) {
        this.θamountInChf.set(coerceDataType(amountInChf, 'number', false, true))
    }

    get exchangeRate(): Orders.ExchangeRate {
        return this.θexchangeRate?.()
    }

    set exchangeRate(exchangeRate) {
        this.θexchangeRate.set(coerceDataType(exchangeRate, Orders.ExchangeRate, false, true))
        if (exchangeRate) {
            this.θexchangeRateId.set(exchangeRate.id)
        } else if (exchangeRate === null && exchangeRate) {
            this.θexchangeRateId.set(null)
        }
    }

    get exchangeRateId(): Orders.ExchangeRate.Id {
        return this.θexchangeRateId?.()
    }

    set exchangeRateId(exchangeRateId) {
        if (exchangeRateId === null) this.θexchangeRate.set(null)
        if (this.exchangeRate?.id && exchangeRateId != this.exchangeRate.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θexchangeRateId.set(coerceDataType(exchangeRateId, 'Orders.ExchangeRate.Id', false, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Orders__ExchangeRateHistory>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Orders__ExchangeRateHistory()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Orders__ExchangeRateHistory>, restrictToClass?: Class<Partial<Orders__ExchangeRateHistory>>) {
        assignCommonProperties(this, source, { restrictToClass })
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('date', 'amountInChf', 'exchangeRate', 'exchangeRateId', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Orders__ExchangeRateHistory {
        return equal(this, other)
    }
}

namespace Orders__ExchangeRateHistory { }

export import ExchangeRateHistory = Orders__ExchangeRateHistory
setTimeout(() => {
    jsonProperty(() => Date)(Orders__ExchangeRateHistory.prototype, 'date')
    jsonProperty(() => Number)(Orders__ExchangeRateHistory.prototype, 'amountInChf')
    jsonProperty(() => Orders.ExchangeRate)(Orders__ExchangeRateHistory.prototype, 'exchangeRate')
    jsonProperty(() => Orders.ExchangeRate.Id)(Orders__ExchangeRateHistory.prototype, 'exchangeRateId')
    jsonProperty(() => Date)(Orders__ExchangeRateHistory.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Orders__ExchangeRateHistory.prototype, 'createdBy')
    jsonProperty(() => Date)(Orders__ExchangeRateHistory.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__ExchangeRateHistory.prototype, 'updatedBy')
    jsonProperty(() => Date)(Orders__ExchangeRateHistory.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__ExchangeRateHistory.prototype, 'deletedBy')
    jsonProperty(() => Number)(Orders__ExchangeRateHistory.prototype, 'versionNumber')
})

export const ExchangeRateHistoryθId = Number;

export type ExchangeRateHistoryθId = number;

namespace Orders__ExchangeRateHistory {
    export type Id = NominalType<number, 'Orders.ExchangeRateHistory'>

}
